import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts

import Index from "views/Index.js";

//about us
import Aboutt from "about/aboutpage/Aboutt.js";

// contact us
import Contactus from "about/aboutpage/Contactus";
import Service from "components/Homepage/Service";
import Blog from "components/Homepage/Blog";
import Industries from "components/Homepage/Industries";
import Product from "components/Homepage/Product";
import Productuae from "components/Homepage/Productuae";
import Popup from "components/Homepage/Popup";
import Slider2 from "components/Homepage/Slider2";
import Slider1 from "components/Homepage/Slider1";
import Slider3 from "components/Homepage/Slider3";
import Form from "components/Homepage/Form";
import Homepagenext from "components/Homepage/Homepagenext";
import Homepage1 from "components/Homepage/India";
import UAE from "components/Homepage/UAE";
import Evoguard from "components/Partner/Evoguard";
import Ampcopumps from "components/Partner/Ampcopumps";
import Perfinoxsa from "components/Partner/Perfinoxsa";
import HSTMaschinenbau from "components/Partner/HSTMaschinenbau";
import Contactuae from "about/Contactuae";


ReactDOM.render(
  <BrowserRouter>
    <Switch>
      {/* add routes with layouts */}
      {/* <Route path="/admin" component={Admin} />
      <Route path="/auth" component={Auth} /> */}
      {/* <Route path="/aboutt" component={Aboutt} /> */}
      {/* add routes without layouts */}
      {/* <Route path="/landing" exact component={Landing} />
      <Route path="/profile" exact component={Profile} /> */}

      {/* Homepage */}

      {/* Aboutus page */}
      <Route path="/about-us" exact component={Aboutt} />
      <Route path="/blog" exact component={Blog} />
      <Route path="/industries" exact component={Industries} />
      <Route path="/product" exact component={Product} />
      <Route path="/productuae" exact component={Productuae} />
      <Route path="/popup" exact component={Popup} />
      <Route path="/slider" exact component={Slider1} />
      <Route path="/index" exact component={Index} />
      <Route path="/slider2" exact component={Slider2} />
      <Route path="/slider3" exact component={Slider3} />
      <Route path="/form" exact component={Form} />
      <Route path="/evoguard" exact component={Evoguard} />
      <Route path="/Homepagenext" exact component={Homepagenext} />
      <Route path="/India" exact component={Homepage1} />
      <Route path="/UAE" exact component={UAE} />
      {/* services */}
      <Route path="/service" exact component={Service} />

      {/* Contact us */}
      <Route path="/contact" exact component={Contactus} />
      <Route path="/contact-uae" exact component={Contactuae} />
      <Route path="/Ampcopumps" exact component={Ampcopumps} />
      <Route path="/Perfinoxsa" exact component={Perfinoxsa} />
      <Route path="/HSTMaschinenbau" exact component={HSTMaschinenbau} />
      <Route path="/" exact component={Index} />
      {/* Inside dropdown content  */}

      {/* add redirect for first page */}
      <Redirect from="*" to="/" />

    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

